import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import isEqual from 'hs-lodash/isEqual';
import { useRouteMatch } from 'react-router-dom';
import UIButton from 'UIComponents/button/UIButton';
import styled, { useMediaQuery } from '../../../utils/Styling';
import { usePlaylistItemSearch } from './PlaylistItemSearchManager'; // @ts-expect-error Could not find a declaration file for module

import { useFetchFilters } from '../../../hooks/catalogPageHooks'; // @ts-expect-error Could not find a declaration file for module

import { useFetchTracksLessonsData } from '../../../hooks/catalogPageHooks'; // @ts-expect-error Could not find a declaration file for module

import PaginatedUICardGrid from '../../../containers/MyLearningPage/PaginatedUICardGrid';
import TrackCardContainer from '../../../containers/TracksPage/TrackCardContainer';
import LessonCardContainer from '../../../components/LessonCard/LessonCardContainer'; // @ts-expect-error Could not find a declaration file for module

import ApiError from '../../../components/Errors/ApiError';
import { AddPlaylistItemIcon, RemovePlaylistItemIcon } from './PlaylistItemManager';
import I18n from 'I18n';
import NoResultsError from '../../../components/Errors/NoResultsError';

const noop = () => {};

const AddRemovePlaylistSearchItemImpl = ({
  className,
  onClick,
  label,
  icon
}) => {
  return /*#__PURE__*/_jsx(UIButton, {
    "aria-label": label,
    className: className,
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    },
    use: "unstyled",
    children: icon
  });
};

const AddRemovePlaylistSearchItem = styled(AddRemovePlaylistSearchItemImpl).withConfig({
  displayName: "PlaylistItemSearchResults__AddRemovePlaylistSearchItem",
  componentId: "sc-1lawhlb-0"
})(["&& > span{width:30px;height:30px;}"]);

const useTrackLessonSearch = () => {
  const [lastSearchResults, setLastSearchResults] = useState(null);
  useFetchTracksLessonsData();
  const {
    tracksLessonsSearchQueryData,
    tracksLessonsSearchQueryLoading,
    tracksLessonsSearchQueryError
  } = useFetchFilters();
  useEffect(() => {
    if (!tracksLessonsSearchQueryLoading && !isEqual(lastSearchResults, tracksLessonsSearchQueryData)) {
      setLastSearchResults(tracksLessonsSearchQueryData);
    }
  }, [tracksLessonsSearchQueryData, lastSearchResults, tracksLessonsSearchQueryLoading]);
  return {
    lastSearchResults,
    tracksLessonsSearchQueryError
  };
};

export const PlaylistItemSearchResults = ({
  onSearchPageChange = noop
}) => {
  const {
    addPlaylistItem,
    removePlaylistItem,
    newPlaylistItems,
    resetQuery
  } = usePlaylistItemSearch();
  const {
    url
  } = useRouteMatch();
  const {
    isMobile
  } = useMediaQuery();
  const {
    lastSearchResults,
    tracksLessonsSearchQueryError
  } = useTrackLessonSearch();

  if (tracksLessonsSearchQueryError) {
    return /*#__PURE__*/_jsx(ApiError, {
      className: "tracks-api-error",
      error: tracksLessonsSearchQueryError,
      marker404: "CATALOG_COURSES_API_404",
      markerDefault: "CATALOG_COURSES_API_ERROR",
      resetLink: url
    });
  }

  if (!lastSearchResults) return null;
  return lastSearchResults.length ? /*#__PURE__*/_jsx(PaginatedUICardGrid, {
    className: isMobile ? 'm-top-5' : '',
    columnSize: 250,
    limit: 12,
    onPageChange: () => {
      onSearchPageChange();
    },
    children: lastSearchResults.map(({
      id,
      contentType,
      data: {
        language,
        name
      }
    }, index) => {
      const playlistItem = {
        itemId: Number(id),
        type: contentType,
        language,
        name,
        hasBeenRemoved: false
      };
      const newPlaylistItem = newPlaylistItems.find(item => item.itemId === playlistItem.itemId && item.type === playlistItem.type);
      const isAdded = newPlaylistItem !== undefined && !(newPlaylistItem && newPlaylistItem.hasBeenRemoved);

      const addRemoveButton = /*#__PURE__*/_jsx(AddRemovePlaylistSearchItem, {
        icon: isAdded ? /*#__PURE__*/_jsx(RemovePlaylistItemIcon, {
          iconSize: "md"
        }) : /*#__PURE__*/_jsx(AddPlaylistItemIcon, {
          iconSize: "md"
        }),
        label: isAdded ? I18n.text('learningCenter.savedItems.playlistDetails.removeFromPlaylist') : I18n.text('learningCenter.savedItems.playlistDetails.addToPlaylist'),
        onClick: () => {
          if (isAdded) {
            removePlaylistItem(playlistItem);
          } else {
            addPlaylistItem(playlistItem);
          }
        }
      });

      return contentType === 'TRACK' ? /*#__PURE__*/_jsx(TrackCardContainer, {
        appearsIn: "filterable-results",
        "data-test-id": `track-${id}`,
        isGhost: newPlaylistItem && newPlaylistItem.hasBeenRemoved,
        language: language,
        position: index + 1,
        preferPreviewModal: true,
        thumbnailHeaderIcons: addRemoveButton,
        trackId: Number(id)
      }, `${id}-${contentType}-${language}`) : /*#__PURE__*/_jsx(LessonCardContainer, {
        appearsIn: "filterable-results",
        "data-test-id": `lesson-${id}`,
        isGhost: newPlaylistItem && newPlaylistItem.hasBeenRemoved,
        language: language,
        lessonId: Number(id),
        position: index + 1,
        preferPreviewModal: true,
        thumbnailHeaderIcons: addRemoveButton
      }, `${id}-${contentType}-${language}`);
    })
  }) : /*#__PURE__*/_jsx(NoResultsError, {
    onReset: resetQuery,
    resetLink: url
  });
};